(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["subscription-selector"] && !Shopify.designMode) return;
  try {
    (function() {
    const selector = document.querySelector('[data-subscription-selector]');
    if (!selector) return;

    const options = selector.querySelectorAll('[data-option]');
    const sellingPlanInput = selector.querySelector('[data-selling-plan-input]');
    const sellingPlansData = JSON.parse(selector.dataset.sellingPlans || '[]');
    const productId = selector.dataset.productId;
    const planButton = selector.querySelector('[data-plan-button]');
    const planDropdown = selector.querySelector('[data-plan-dropdown]');
    const planList = selector.querySelector('[data-plan-list]');
    const planButtonText = selector.querySelector('[data-plan-button-text]');

    // Get current variant ID from product form
    function getCurrentVariantId() {
      const form = document.querySelector('form[data-type="add-to-cart-form"]');
      if (!form) return null;
      const variantInput = form.querySelector('input[name="id"]');
      return variantInput ? variantInput.value : null;
    }

    // Find all selling plans for current variant
    function findSellingPlansForVariant(variantId) {
      if (!variantId || sellingPlansData.length === 0) return [];
      return sellingPlansData.filter(plan => plan.variant_id.toString() === variantId.toString());
    }

    // Find specific selling plan by ID
    function findSellingPlanById(planId) {
      return sellingPlansData.find(plan => plan.selling_plan_id.toString() === planId.toString());
    }

    // Format money from cents
    function formatMoney(cents) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
      }).format(cents / 100);
    }

    // Update prices based on selected plan
    function updatePrices(selectedPlan = null) {
      const variantId = getCurrentVariantId();
      if (!variantId) return;

      const subscribeOption = selector.querySelector('[data-option="subscribe"]');
      const oneTimeOption = selector.querySelector('[data-option="one-time"]');

      // Update one-time price
      const oneTimePriceEl = oneTimeOption.querySelector('[data-one-time-price]');
      const oneTimeCompareEl = oneTimeOption.querySelector('[data-one-time-compare]');
      
      // Get variant data from DOM (prices are updated by variant picker)
      const form = document.querySelector('form[data-type="add-to-cart-form"]');
      if (form) {
        const variantInput = form.querySelector('input[name="id"]');
        if (variantInput) {
          // Try to get price from price block if available
          const priceBlock = document.querySelector('[data-product-price]');
          if (priceBlock) {
            const priceText = priceBlock.textContent.trim();
            if (oneTimePriceEl) oneTimePriceEl.textContent = priceText;
          }
        }
      }

      // Get plan to use (either passed in or find first for variant)
      let plan = selectedPlan;
      if (!plan) {
        const plans = findSellingPlansForVariant(variantId);
        plan = plans.length > 0 ? plans[0] : null;
      }

      // Update subscribe price if plan exists
      if (plan && subscribeOption && !subscribeOption.classList.contains('subscription-selector__option--disabled')) {
        const subscribePriceEl = subscribeOption.querySelector('[data-subscribe-price]');
        const subscribeCompareEl = subscribeOption.querySelector('[data-subscribe-compare]');
        const discountEl = subscribeOption.querySelector('[data-discount-percentage]');

        if (subscribePriceEl) {
          subscribePriceEl.textContent = formatMoney(plan.subscription_price);
        }

        if (subscribeCompareEl && plan.compare_at_price > plan.price) {
          subscribeCompareEl.textContent = formatMoney(plan.compare_at_price);
          subscribeCompareEl.style.display = '';
        } else if (subscribeCompareEl) {
          subscribeCompareEl.style.display = 'none';
        }

        // Update discount badge
        if (discountEl) {
          const basePrice = plan.compare_at_price > plan.price ? plan.compare_at_price : plan.price;
          const discount = basePrice - plan.subscription_price;
          if (discount > 0) {
            const discountPercent = Math.round((discount / basePrice) * 100);
            discountEl.textContent = discountPercent + '%';
            discountEl.closest('.subscription-selector__discount-badge').style.display = '';
          } else {
            discountEl.closest('.subscription-selector__discount-badge').style.display = 'none';
          }
        }

        // Update selling plan input if subscribe is active
        if (subscribeOption.classList.contains('subscription-selector__option--active') && sellingPlanInput) {
          sellingPlanInput.value = plan.selling_plan_id;
        }
      }
    }

    // Populate selling plan dropdown
    function populatePlanOptions() {
      if (!planList) return;

      const variantId = getCurrentVariantId();
      if (!variantId) return;

      const plans = findSellingPlansForVariant(variantId);
      
      // Clear existing options
      planList.innerHTML = '';

      if (plans.length === 0) {
        if (planButton) {
          planButton.style.display = 'none';
        }
        return;
      }

      // Show/hide dropdown arrow based on number of options
      const hasMultipleOptions = plans.length > 1;
      if (planButton) {
        const arrowIcon = planButton.querySelector('svg');
        if (arrowIcon) {
          arrowIcon.style.display = hasMultipleOptions ? '' : 'none';
        }
        planButton.style.cursor = hasMultipleOptions ? 'pointer' : 'default';
        planButton.setAttribute('data-has-multiple-options', hasMultipleOptions);
      }

      // If only one plan, auto-select it
      if (plans.length === 1) {
        const plan = plans[0];
        if (planButtonText) {
          planButtonText.textContent = plan.frequency;
        }
        if (sellingPlanInput && selector.querySelector('[data-option="subscribe"]').classList.contains('subscription-selector__option--active')) {
          sellingPlanInput.value = plan.selling_plan_id;
        }
        updatePrices(plan);
        
        // Still create the option for display
        const li = document.createElement('li');
        li.className = 'subscription-selector__plan-item subscription-selector__plan-item--active';
        li.textContent = plan.frequency;
        li.setAttribute('data-plan-id', plan.selling_plan_id);
        li.style.cursor = 'default';
        planList.appendChild(li);
        
        if (planDropdown) {
          planDropdown.style.display = 'none';
        }
        if (planButton) {
          planButton.setAttribute('aria-expanded', 'false');
        }
        return;
      }

      // Multiple plans - create clickable options
      plans.forEach((plan) => {
        const li = document.createElement('li');
        li.className = 'subscription-selector__plan-item';
        li.textContent = plan.frequency;
        li.setAttribute('data-plan-id', plan.selling_plan_id);
        li.planData = plan;
        
        li.addEventListener('click', function (e) {
          e.stopPropagation();
          
          // Update active state
          planList.querySelectorAll('.subscription-selector__plan-item').forEach((item) => {
            item.classList.remove('subscription-selector__plan-item--active');
          });
          li.classList.add('subscription-selector__plan-item--active');

          // Update button text
          if (planButtonText) {
            planButtonText.textContent = plan.frequency;
          }

          // Update prices and selling plan input
          updatePrices(plan);
          if (sellingPlanInput && selector.querySelector('[data-option="subscribe"]').classList.contains('subscription-selector__option--active')) {
            sellingPlanInput.value = plan.selling_plan_id;
          }

          // Close dropdown
          if (planDropdown) {
            planDropdown.style.display = 'none';
          }
          if (planButton) {
            planButton.setAttribute('aria-expanded', 'false');
          }
        });

        planList.appendChild(li);
      });

      // Set initial active state
      const currentPlanId = sellingPlanInput ? sellingPlanInput.value : null;
      if (currentPlanId) {
        planList.querySelectorAll('.subscription-selector__plan-item').forEach((item) => {
          if (item.dataset.planId === currentPlanId) {
            item.classList.add('subscription-selector__plan-item--active');
            if (planButtonText && item.planData) {
              planButtonText.textContent = item.planData.frequency;
            }
          }
        });
      } else if (plans.length > 0) {
        // Select first plan by default
        const firstPlan = plans[0];
        const firstItem = planList.querySelector('.subscription-selector__plan-item');
        if (firstItem) {
          firstItem.classList.add('subscription-selector__plan-item--active');
        }
        if (planButtonText) {
          planButtonText.textContent = firstPlan.frequency;
        }
        updatePrices(firstPlan);
        if (sellingPlanInput && selector.querySelector('[data-option="subscribe"]').classList.contains('subscription-selector__option--active')) {
          sellingPlanInput.value = firstPlan.selling_plan_id;
        }
      }
    }

    // Handle option selection
    function selectOption(option) {
      if (option.classList.contains('subscription-selector__option--disabled')) return;

      // Remove active state from all options
      options.forEach(opt => {
        opt.classList.remove('subscription-selector__option--active');
        opt.setAttribute('aria-pressed', 'false');
      });

      // Add active state to selected option
      option.classList.add('subscription-selector__option--active');
      option.setAttribute('aria-pressed', 'true');

      // Update selling plan input
      if (sellingPlanInput) {
        const optionType = option.dataset.option;
        if (optionType === 'subscribe') {
          // Repopulate plans and select first one
          populatePlanOptions();
        } else {
          sellingPlanInput.value = '';
        }
      }
    }

    // Add click handlers for option cards
    options.forEach(option => {
      // Don't trigger selection when clicking inside the plan selector
      option.addEventListener('click', (e) => {
        if (e.target.closest('.subscription-selector__plan-selector')) {
          return;
        }
        selectOption(option);
      });
      
      option.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectOption(option);
        }
      });
    });

    // Toggle plan dropdown
    if (planButton && planDropdown) {
      planButton.addEventListener('click', function (e) {
        e.stopPropagation();
        
        const hasMultipleOptions = this.getAttribute('data-has-multiple-options') === 'true';
        if (!hasMultipleOptions) {
          return;
        }
        
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        
        if (!isExpanded) {
          populatePlanOptions();
        }
        
        this.setAttribute('aria-expanded', !isExpanded);

        if (isExpanded) {
          planDropdown.style.display = 'none';
        } else {
          planDropdown.style.display = 'block';
        }
      });

      // Close dropdown when clicking outside
      document.addEventListener('click', function (e) {
        if (!planButton.contains(e.target) && !planDropdown.contains(e.target)) {
          planDropdown.style.display = 'none';
          planButton.setAttribute('aria-expanded', 'false');
        }
      });
    }

    // Listen for variant changes
    const variantObserver = new MutationObserver(() => {
      populatePlanOptions();
      updatePrices();
    });

    const form = document.querySelector('form[data-type="add-to-cart-form"]');
    if (form) {
      const variantInput = form.querySelector('input[name="id"]');
      if (variantInput) {
        variantObserver.observe(variantInput, { attributes: true, attributeFilter: ['value'] });
      }
    }

    // Listen for custom variant change events
    document.addEventListener('variant:change', () => {
      populatePlanOptions();
      updatePrices();
    });

    // Initial setup
    populatePlanOptions();
    updatePrices();

    // Handle subscription info dialog aria-expanded
    const subscriptionInfoDialog = document.querySelector('.subscription-info-dialog');
    const subscriptionInfoButton = document.querySelector('.subscription-info-button');
    if (subscriptionInfoDialog && subscriptionInfoButton) {
      const dialog = subscriptionInfoDialog.querySelector('dialog');
      if (dialog) {
        // Update aria-expanded when dialog opens/closes
        const observer = new MutationObserver(() => {
          const isOpen = dialog.hasAttribute('open');
          subscriptionInfoButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });

        observer.observe(dialog, {
          attributes: true,
          attributeFilter: ['open']
        });

        // Initial state
        subscriptionInfoButton.setAttribute('aria-expanded', dialog.hasAttribute('open') ? 'true' : 'false');
      }
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
